export enum PricePlanTypeEnum {
  OneShot = 'one_shot',
  Subscription = 'subscription',
  LimitedSubscription = 'limited_subscription',
}
